import FixOrUpgradeAction from '@/classes/SubmissionActions/FixOrUpgradeAction'
import { BaseEverplansStatus } from '@/classes/SubmissionStatuses/BaseEverplansStatus'
import { StatusThemeVariant } from '@/classes/SubmissionStatuses/StatusThemeVariantEnum'
import { type SubmissionAction } from '@/classes/SubmissionStatuses/types'

/**
 * This status is ONLY for Basic plans.
 * If email is missing with Premium it should be an EmailError.
 */
export class EmailMissing extends BaseEverplansStatus {
	getActions(): Array<SubmissionAction> {
		return [
			new FixOrUpgradeAction(
				this.submissionStatus.emailStatus!.status, // TODO see if we can type narrow this
				this.submissionStatus.requestedAccountTier,
				this.submissionStatus.lastSubmittedEmail,
				this.submissionStatus.paymentAmount,
				'Add'
			),
		]
	}

	getStatusText() {
		return 'Basic | Missing Email'
	}

	getToolTipText() {
		return {
			title: this.getStatusText(),
			body: 'There is no email attached to this Everplans account. Click Add button to update and submit to Everplans. Have questions? Contact salesstudio@precoa.com.',
		}
	}

	getThemeVariant() {
		return StatusThemeVariant.NEUTRAL
	}
}
